// @flow
import * as React from 'react';
import { Box, Button } from 'grommet';
import { FormClose } from 'grommet-icons';
import FileInfo from './FileInfo';

// SOURCE: https://github.com/taysea/grommet-dropzone

type Props = {
    ...React.ElementConfig<Box>,
    file: {
        name: string,
        size: number,
        type: string,
        path: string,
        preview?: string,
    },
    showPreview: boolean,
    showFileSize: boolean,
    removeFile: Function,
}

const File = (props: Props) => {
    const {
        file,
        removeFile,
        showPreview,
        showFileSize,
        ...rest
    } = props;

    return (
        <Box direction="row" align="center" justify="between" {...rest}>
            <FileInfo
                file={file}
                showFileSize={showFileSize}
                showPreview={showPreview}
            />
            <Button
                a11yTitle={`remove ${file.path}`}
                icon={<FormClose />}
                hoverIndicator
                onClick={() => removeFile(file)}
            />
        </Box>
    );
};

export default File;
